import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./GetUserDetailsForm.css";
import {
  englishUser,
  sinhalaUser,
  tamilUser,
} from "../../../dummyData/getUserDetailsFormData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { cities } from "../../../dummyData/cities";
import { db } from "../../../firebase/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Index() {
  const navigate = useNavigate();

  const selectedLanguage = useSelector((state) => state.language.language);

  const [language, setLanguage] = useState(sinhalaUser);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    age: "",
    closedCity: "",
    district: "",
  });

  const [cityList, setCityList] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishUser);
        break;
      case "tamil":
        setLanguage(tamilUser);
        break;
      default:
        setLanguage(sinhalaUser);
        break;
    }
  }, [selectedLanguage]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [id]: id === "age" ? (value ? parseInt(value, 10) : "") : value,
    }));

    if (id === "district") {
      const selectedCities = cities[value]?.cities || [];
      setCityList(selectedCities);
      setFormData((prevState) => ({
        ...prevState,
        closedCity: "",
      }));
    }
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!formData.name) {
      formErrors.name = "Name is required";
      isValid = false;
    }
    if (!formData.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (
      !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.email)
    ) {
      formErrors.email =
        "Email must contain only lowercase letters and be valid";
      isValid = false;
    }
    if (!formData.phoneNumber) {
      formErrors.phoneNumber = "Phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      formErrors.phoneNumber = "Phone number must be 10 digits";
      isValid = false;
    }
    if (!String(formData.age).trim()) {
      formErrors.age = "Age is required";
      isValid = false;
    } else {
      const age = parseInt(formData.age, 10);
      if (isNaN(age) || age < 17 || age > 120) {
        formErrors.age = "Age must be a number between 10 and 120";
        isValid = false;
      }
    }
    if (!formData.closedCity) {
      formErrors.closedCity = "City is required";
      isValid = false;
    }
    if (!formData.district) {
      formErrors.district = "District is required";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        await addDoc(collection(db, "getUserDetails"), {
          ...formData,
          createdAt: serverTimestamp(),
        });
        console.log("Form Data Saved:", formData);
        Swal.fire({
          title: "Success",
          text: language.successMsg,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/");
        });
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          age: "",
          closedCity: "",
          district: "",
        });
      } catch (error) {
        console.error("Error saving to Firestore:", error);
        Swal.fire({
          title: "Error",
          text: language.errorMsg,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <>
      <div className="container-fluid d-flex justify-content-center align-items-center px-md-5 pt-5 min-vh-100">
        <div className="row d-flex justify-content-center mb-4 pt-5">
          {/* <div className="col-12 d-flex justify-content-start mb-3"></div> */}
          <div className="ps-3 pt-4 back-button-grid">
            <button onClick={() => navigate(-1)} className="btn p-1">
              <i className="bi bi-arrow-left fs-4"></i>
            </button>
          </div>

          <h3 className="fs-1 text-dark my-3">
            {language.formTitleFirst}{" "}
            <span className="text-warning fw-bold">
              {language.formTitleSecond}
            </span>{" "}
          </h3>

          <form className="row g-3 p-4 p-lg-5 user-form col-12">
            <div className="col-md-6">
              <label htmlFor="name" className="user-reg-form-label">
                {language.name}
              </label>
              <input
                type="text"
                className="form-control user-reg-form-label"
                id="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder={language.namePlaceholder}
              />

              {errors.name && <p className="text-danger">{errors.name}</p>}
            </div>

            <div className="col-md-6">
              <label htmlFor="age" className="user-reg-form-label">
                {language.age}
              </label>
              <input
                id="age"
                value={formData.age}
                onChange={handleInputChange}
                className="form-control user-reg-form-label"
                type="text"
                placeholder={language.agePlaceholder}
              />
              {errors.age && <p className="text-danger">{errors.age}</p>}
            </div>

            <div className="col-md-6">
              <label htmlFor="email" className="user-reg-form-label">
                {language.email}
              </label>
              <input
                type="email"
                className="form-control user-reg-form-label"
                id="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder={language.emailPlaceholder}
              />
              {errors.email && <p className="text-danger">{errors.email}</p>}
            </div>

            <div className="col-md-6">
              <label htmlFor="mobile" className="user-reg-form-label">
                {language.phoneNumber}
              </label>
              <input
                id="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="form-control user-reg-form-label"
                type="text"
                placeholder={language.phoneNumberPlaceholder}
              />
              {errors.phoneNumber && (
                <p className="text-danger">{errors.phoneNumber}</p>
              )}
            </div>

            {/* District Selection */}
            <div className="col-md-6">
              <label htmlFor="district" className="user-reg-form-label">
                {language.district}
              </label>
              <select
                className="form-select form-select-value"
                id="district"
                value={formData.district}
                onChange={handleInputChange}
              >
                <option value="">{language.districtPlaceholder}</option>
                {Object.keys(cities).map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </select>
              {errors.district && (
                <p className="text-danger">{errors.district}</p>
              )}
            </div>

            {/* City Selection enable after Select District*/}
            <div className="col-md-6">
              <label htmlFor="closedCity" className="user-reg-form-label">
                {language.closedCity}
              </label>
              <select
                className="form-select form-select-value"
                id="closedCity"
                value={formData.closedCity}
                onChange={handleInputChange}
                disabled={!formData.district} // Disable if district is not selected
              >
                <option value="">{language.closedCityPlaceholder}</option>
                {cityList.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {errors.closedCity && (
                <p className="text-danger">{errors.closedCity}</p>
              )}
            </div>
          </form>
          <div className="col-12 d-flex justify-content-center">
            <button
              className="btn btn-secondary px-4 py-2 m-2 d-none d-sm-block"
              onClick={() => navigate(-1)}
              aria-label="Go Back"
            >
              {language.back}
            </button>
            <button
              type="submit"
              className="btn form-btn text-light px-4 py-2 m-2"
              onClick={handleSubmit}
            >
              {language.submit}
            </button>
          </div>
          <div
            className="d-flex justify-content-end align-items-end p-3"
            style={{ zIndex: "100", left: "initial" }}
          >
            <a
              href="https://wa.me/94712367846"
              target="_blank"
              rel="noopener noreferrer"
              className="m-2"
              alt="Chat with MechSIT on WhatsApp"
            >
              {/* <Image src={WhatsAppIMG} width={180} /> */}
              <FontAwesomeIcon
                icon={faWhatsapp}
                size={`${
                  window.innerWidth < 768
                    ? "2x"
                    : window.innerWidth < 992
                    ? "3x"
                    : "4x"
                }`}
                color="#25D366"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
